module.exports = __webpack_public_path__ + "img/correct.de3c53eb.svg";